export const getObjectToFormData = (obj: object): FormData => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(obj)) {
    if (value === null || value === undefined) continue;
    if (typeof value === 'number' || typeof value === 'boolean') {
      formData.append(key, String(value));
    } else if (value instanceof Blob || typeof value === 'string') {
      formData.append(key, value);
    }
  }
  return formData;
};
